import { UiStrings } from "./UiStrings";

export const UiStringsEn: UiStrings = {
  common: {
    dismiss: 'Dismiss',
    close: 'Close',
    continue: 'Continue',
    back: 'Back',
    xp: 'XP',
    explain: 'Explain',
    and: 'and',
    or: 'or',
    secShort: 's',
    minShort: 'min',
    saveChanges: 'Save Changes',
    logout: 'Logout',
    ago: 'ago',
    yes: "Yes",
    no: "No",
    translate: "Translate",
    saveTerm: 'Save Vocab',
    tryAgain: "Try Again",
    pleaseWait: "Please wait...",
    checkAgainLater: "Check again later",
    errors: {
      tooManyRequests: "You used this too many times, please try again later.",
    }
  },
  nav: {
    header: {
      tabs: {
        workbook: 'Workbook',
        contacts: 'Contacts',
        feed: 'For You',
        recent: 'Recent',
        games: 'Games',
      }
    },
    bottomBar: {
      home: 'Home',
      contacts: 'Contacts',
      feed: 'Feed',
      inbox: 'Inbox',
      vocab: 'Vocab',
    }
  },
  tryit: {
    existingUsersLogin: 'Existing users login here',
  },
  login: {
    title: 'Login',
    welcome: 'Welcome to the app',
    requestCodeButton: 'Request Login Code:',
    requestCodeInfo: 'Use either Telegram or email to request a login code that you need to enter back here.',
    codeInputLabel: 'Authentication Code',
    verifyCodeButton: 'Verify Code',
    verifying: 'Verifying...',
    codeInputPlaceholder: 'Code from Telegram',
    codeEmailInputPlaceholder: 'Code from email',
    codeInputError: 'Invalid code',
    codeInputSuccess: 'Code verified successfully',
    cancel: 'Cancel',
    emailInputLabel: 'Email Address',
    emailInputPlaceholder: 'Enter your email',
    sendCodeButton: 'Send Code',
    sendingCode: 'Sending...',
    checkEmail: 'Check your email for the authentication code',
    codeExpiresIn: 'Code expires in',
    resendCode: 'Resend Code',    
    selectNativeLanguage: 'Select your native language',
  },
  landing: {
    demoChat: {
      tagline: 'Speaking practice with AI tutor 🎤👂💥',
      correction: 'Correction',
      responseOptions: 'Response options',
    },
    testimonials: {
      title: 'What our users say',
    },
    learningMotivation: {
      title: 'Useful in different situations',
    },
    voiceExamples: {
      title: "Lifelike AI Conversations",
      detail: "Practice with our AI tutors using natural, human-like voices for realistic language immersion in any language.",
      listen: "Listen",
      pause: "Pause",
      playing: "Playing...",
      info: {
        title: "Speak naturally with AI tutors that sound human",
        chip1: "Flexible topics",
        chip2: "Learning tools",
        chip3: "Detailed feedback",
        chip4: "Realistic voices",
      },
      leadOut: "Our AI tutors use premium voice models that sound natural and respond to you in real-time."
    },
    betterWithTelegram: {
      title: "Better with Telegram",
      info: "Our AI bot is integrated with Telegram and can intelligently respond to your messages and assist practice and exam follow ups.",
      info2: "Chatlanga Telegram bot will be your trusted practicing partner for your grammar and expression skills.",
    },
    videoCarousel: {
      practiceStart: "Choose a range of topics and games or use your own ideas 💡",
      fluencyMeter: "Real-time fluency meter tracks your progress ⏱️",
      tapTranslations: "Unknown words? Translate any message by tapping it 🌐",
      responseOptions: "Low-stress practice with AI response suggestions 😌",
    },
    knowledgeBase: {
      title: "Learning Resources",
      info: "For some languages, Chatlanga offers public learning resources tailored for native speakers of different cultures.",
      info2: "Our constantly growing knowledge base is a collection of articles, quizzes and audio comprehension exercises across different topics and grammar aspects of the language.",
    }
  },
  dashboard: {
    progress: {
      title: 'Progress',
      description: 'Track your progress in your language',
      currentRank: 'Current Rank',
      nextRank: 'Next Rank',
      practicesTaken: 'Practices taken',
      examsTaken: 'Exams taken',
      wordsLearned: 'Words learned',
      vocabSize: 'Vocab size',      
    },
    practice: {
      title: 'Voice Call',
      description: 'Practice your language with our practice sessions',
    },
    chatPractice: {
      title: 'Voice Chat',
      description: 'Practice your language with our chat sessions',
    },
    exam: {
      title: 'Exam Simulation',
      description: 'Take your language exam with our exam simulation',
      notAvailable: 'Not available yet, coming soon...',
    },
    corrections: {
      title: 'Recent Mistakes',
      description: 'View your recent mistakes',
      noMistakes: 'Mistakes cleared! Keep it up!',
      noSessions: 'Try your first practice session to improve your language skills!',
      dismissing: 'Dismissing correction...',
      originalPhrase: 'Original phrase',
      correction: 'Correction',
      comment: 'Comment',
      showMore: 'Show all',
      showLess: 'Show less',
    },
    vocabulary: {
      title: 'New Vocabulary',
      description: 'View your new vocabulary',
      buttonLearn: 'Learned',
      buttonDismiss: 'Dismiss',
      originalPhrase: 'Original phrase',
      updating: 'Updating vocabulary...',
    },
    recentConversations: {
      title: 'Recent Conversations',      
      noSessions: 'No conversations yet. Try a practice conversation!',            
    },
    chatExercises: {
      title: 'Chat Exercises',
      info: 'Get a random exercise from our AI tutor in your Telegram app',
      send: 'Send',
      more: 'More',
    },
    articles: {
      title: 'Articles for You',
    },
    rewards: {
      title: 'Rewards',
      noRewards: 'No rewards yet',
    }
  },
  creditsInfo: {
    credits: 'credits',    
    one_credit: 'credit',
    many_credits: 'credits',
    inflectCredits: function(count: number, form: 'nominative' | 'genitive' | 'dative' | 'accusative' | 'instrumental' | 'prepositional') {
      if (count === 1) {
        return `${this.one_credit}`;
      }
      return `${this.many_credits}`;
    },
    buyMoreCredits: 'Buy More',
  },
  languages: {
    title: 'Language Settings',
    backToDashboard: 'Back to Dashboard',
    appLanguage: 'App Language',
    selectLanguageLabel: 'Select the language you want to learn:',
    messages: {
      levelNotAvailable: 'Level not available',
      levelNotAvailableDescription: '⏳  Coming soon within a few weeks! Tutor for this level is not available yet.',
    }
  },
  examDetails: {
    spanish: {
      oral: {
        beginner: {
          instructions: 'You are given a monologue topic and a dialogue topic. You will have 10 minutes to prepare your monologue and dialogue. After that, you will be shown an image which you\'ll need to describe.',
        },
        beginnerIntermediate: {
          instructions: '',
        },
        intermediate: {
          instructions: '',
        },
        advanced: {
          instructions: '',
        },
      }
    },
    german: {
      oral: {
        beginner: {
          instructions: 'You will be given a monologue topic and a dialogue topic. You will have 10 minutes to prepare your monologue and dialogue. After that, you will be shown an image which you\'ll need to describe.',
        },
        beginnerIntermediate: {
          instructions: '',
        },
        intermediate: {
          instructions: '',
        },
        advanced: {
          instructions: '',
        },
      }
    }
  },
  exam: {
    stages: {
      monologue: 'Monologue',
      dialogue: 'Dialogue',
      describing: 'Image Describing',
    },
    scoreComponents: {
      hollistic: 'Hollistic',
      corrections: 'Grammar',
      fluency: 'Fluency',
      reach: 'Reach',
      coherence: 'Coherence',
    },
    completed: {
      sendSummary: 'Send Summary',
      overall: {
        title: 'Overall',
      },
      stageScores: {
        title: 'Scores by Stage',
        max: 'Max',
        mean: 'Mean',
      },
      skills: {
        title: 'Skills Assessment',
        detail: 'Further away from center means better, best results look like a fully filled diamond 🔹',
      },
      observations: {
        title: 'Observations',
        emptyCategory: 'No observations in this category',
      },
      corrections: {
        title: 'Corrections',
        emptyList: 'No corrections detected',
      }
    }
  },
  beforeConversation: {
    silencePlease: "Quiet environment needed",
    silenceInfo: "Make sure you're in a quiet room and no one is speaking next to you",
  },
  beforeExam: {
    title: 'Exam Simulation',
    approximateSimulation: 'Approximate simulation',
    examDurationMinutes: 'min',
    tutorLabel: 'Exam is led by:',
    yourTicket: 'Your exam topics:',
    welcome: function(firstName: string) {
      return `Welcome, ${firstName}!`;
    },
    audioPermissions: {
      title: 'Audio Permissions',
      ensurePermissions: 'Prepare your mic and headphones or speakers:',      
    },
    examStages: {
      monologue: 'Monologue',
      dialogue: 'Dialogue',      
    },
    startExam: "Start Exam",
    startFirstStage: "Start",
  },
  beforePractice: {
    title: 'Practice Time!',
    tutorShortIntro: 'Your practice tutor:',
    connectingWith: 'Connecting with',
    welcome: function(firstName: string) {
      return `Welcome, ${firstName}!`;
    },
    notEnoughCredits: 'Add credits',
    muteNotice: 'Please ensure that 🔇 => 🔊 your browser tab is not unmuted.',
    audioPermissions: {
      title: 'Audio Permissions',
      ensurePermissions: 'Prepare your mic and headphones or speakers:',      
    },
    configurePractice: "Prepare Practice",
    startPractice: "Start",
    settings: {
      title: 'Practice Settings',
      motherLanguage: 'Your native language',
      targetLanguage: 'Language to practice',
      languageLevel: 'Your level',
      continue: 'Continue to practice',
      edit: 'Change',
    },
    userGoals: {
      default: 'Fluency',
      exam: 'Exam prep',
      travelTo: 'Travel/moving',
      jobInterview: 'Job/promotion',
      relationship: 'Relationship language',
      rentApartment: 'Renting an apartment',
      talkToAccountant: 'Money & taxes',
      talkToDoctor: 'At the doctor\'s',
      escapeRoom: 'Escape room',
      treasureHunt: 'Treasure hunt',
      grammarExercises: 'Grammar exercises',
      wordGame: 'Word game',
      practiceIntro: 'Welcome tour',
      custom: 'Write your own goal',
    }
  },
  userGoalsDialog: {
    title: 'What\'s your practice goal?',
    subtitle: 'Choose a practice goal to customize your conversation with the tutor',
    customGoal: 'Your custom goal',
    customGoalPlaceholder: 'e.g. "Talk to my squad mates in Fortnite"',
  },
  audioPermissions: {
    enableMicrophone: 'Enable microphone and unmute',
    clickToFix: 'Click to fix',
    microphone: 'Microphone',
    microphoneNotEnabled: 'Microphone is currently not enabled, click the button to enable it:',
  },
  audioDeviceSelector: {
    microphone: 'Microphone',
    speakers: 'Headphones or Speaker:',
    muteNote: '* You may also need to unmute the browser tab',
  },
  topicSelection: {
    title: 'Select a Topic',
    instructions: "Click the button below to randomly select your speaking topic.\n You'll have 10 minutes to prepare your presentation.",
    button: 'Draw Topic',
    info1: "The exam simulation consists of two parts: 1) your introduction and monologue on a given topic, and 2) a conversation with the examiner, where you'll be asked questions within an imaginary situational context.",
    info2: "You'll have 10 minutes to prepare your presentation, after which the conversation will begin. You can skip the wait and start the conversation earlier, if you want.",
    skipWait: 'Start',
    anotherTopic: 'Another Topic',
    topicDescription: 'Description',
    topicInstructions: 'Instructions',
  },
  examFlow: {
    describeImage: {
      defaultInstruction: "Describe the situation depicted on this image",
    }
  },
  rating: {
    title: 'Thank you for your presentation!',
    nextUp: 'Next Up:',
    conversation: 'Conversation skills assessment',
    continue: 'Continue',
  },
  conversationInterface: {
    start: 'Start',
    abort: 'Finish',
    continue: 'Continue',
    pleaseWait: 'Please wait...',
    stageNames: {
      intro: 'Introduction',
      monologue: 'Monologue',
      dialogue: 'Dialogue',
      practice: 'Practice',
    },
    conversationState: {
      ready: 'Ready to Start',
      inProgress: 'Conversation in Progress',
      clickToEnd: 'Click the button below to end the conversation',
      clickToStart: 'Click the button below to start speaking',
    },
    countdown: {
      timeLeft: 'Time left:',
      timeUp: 'Your time is almost up, finish up and say goodbye!',
      timeLeftToPrepare: 'Time left to prepare:',
    }
  },
  practiceSessionBoard: {
    title: 'Tutor\'s notes',
    transcriptionTitle: 'Conversation text',
    yourTurnToSpeak: 'Your turn to speak',
    mistakesDetected: 'Mistakes detected',
    vocab: {
      title: 'New Vocabulary',
      dismissKnown: 'Ignore',
      willBeSent: 'This will be sent to you after the session',
      emptyList: 'No new words so far',
    },
    corrections: {
      title: 'Corrections',
      dismiss: 'Ignore',
      willBeSent: 'This will be sent to you after the session',
      emptyList: 'No corrections so far',
    },
    history: {
      title: 'Conversation History',
      emptyList: 'Nothing said yet',
      you: 'You',
      tutor: 'Tutor',
    },
  },
  footer: {
    support: 'Support',
    checkWebsite: 'Check our website',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    acceptTerms: 'I accept the terms of service and privacy policy',    
  },
  profile: {
    referral: {
      title: 'Invite and get credits',
      description: 'Share your referral link with friends. When they sign up, you\'ll both get bonus credits!',
      copied: 'Copied!',
      copy: 'Copy',
      invitedCount: function(count: number) {
        return `You've invited ${count} friends so far!`;
      },
    },
    personal: {
      title: 'Your Personal Data',
      firstName: 'First Name',
      lastName: 'Last Name',
      telegramUsername: 'Telegram Username',
      notConnected: 'Not connected',
      telegramLinked: 'Linked to your Telegram account',
    },
    notifications: {
      title: 'Notifications',
      practiceReminders: 'Practice Reminders via Telegram',
      practiceRemindersDescription: 'Get reminders to practice through our Telegram bot',
      reminderFrequency: 'Reminder Frequency',
      frequentDaily: 'Frequent (Daily)',
      moderateWeekly: 'Moderate (2-3 times per week)',
      rareWeekly: 'Rare (Weekly)',
    },
    chatResponses: 'AI chat responses left today',
    deleteAccount: {
      deleteButton: 'Delete Account',
      deleteButtonInfo: 'This will delete your account and all your data. Remaining data might take up to 6 days to be completely deleted.',
      deleteConfirmation: 'CONFIRM: Are you sure you want to delete your account? This action cannot be undone!',
    },
    tutorials: {
      resetButton: 'Reset Tutorials',
      resetButtonInfo: 'This will reset all your seen hints (tutorial messages at the bottom of the screen) and will make them appear again at least once.',
      notifications: {
        tutorialsReset: 'Tutorial hints have been reset',
      }
    }
  },
  assessmentLoading: {
    title: 'Assessment in Progress',
    subtitle: 'Please wait while we process your results...',
    stateComplete: 'Complete',
    step1Label: 'Collecting transcript',
    step2Label: 'Analyzing grammar',
    step3Label: 'Scoring vocabulary',
    step4Label: 'Ranking fluency',
    step5Label: 'Generating corrections',
    step6Label: 'Creating recommendations',
  },
  assessmentDetails: {
    title: 'Assessment Details',
    practice: 'Practice',
    monologue: 'Monologue',
    dialogue: 'Dialogue',
    grammar: 'Grammar',
    vocabulary: 'Vocabulary',
    fluency: 'Fluency',
    fluencyChart: 'Fluency in this conversation',
    pronunciation: 'Pronunciation',
    overall: 'Overall',
    corrections: 'Corrections',
  },
  practiceCompleted: {
    tryAgainButton: 'Try Again',
    sendSummaryButton: 'Send Summary',
    firstTryIssues: {
      info1: "We noticed that you've had some issues! This is fine! If you don't know how to say something, you can speak in your native language.",
      info2: "Tap the messages to translate them to your native language.",
      info3: "Don't worry! We offer you a free retry, just start a new practice session right now:",
      retryButton: "Retry for free now",
    },
    creditsLeft: (credits: number) => `You have ${credits} ${UiStringsEn.creditsInfo.inflectCredits(credits, 'genitive')} remaining`,
    tryGameModes: "Try our challenging game modes:",
    tryWithCreditsInfo: (credits: number, sessionsLeft: number, price: number) => `With ${credits} credits you can try ${sessionsLeft} more times! At the end of each session you will be charged ${price} credits.`,
  },  
  converationAudioIssues: {
    title: "No Speech Detected",
    noSpeechDetected: "We couldn't detect any speech during your practice session. This might be due to technical issues with your microphone setup.",
    pleaseCheck: "Please check the following:",
    ensureSilentModeOff: "Ensure your device's <b>silent mode is off</b> and volume is turned up",
    ensureMicrophoneEnabled: "Check that your <b>microphone is enabled</b> in your browser's settings",    
    checkHeadset: "Check that you are using <b>either a headset or external speakers</b> but not both",
    ensureTabNotMuted: "Ensure that your browser tab is <b>not muted</b>",
  },
  onboarding: {
    title: "Personal Information",
    welcome: "Let's personalize your learning experience",
    continue: "Continue",
    welcomeSubtitle: "Get started with your fluency journey",
    welcomeInfo: "Complete the form below to get started. Each section will unlock as you complete the previous one.",
    personalInfo: {
      title: "Personal Information",
      firstName: "First name",
      firstNameInfo: "AI tutors will use this name to address you",
      firstNamePlaceholder: "Your first name",
      lastName: "Last name",
      lastNamePlaceholder: "Your last name",
    },
    languageInfo: {
      title: "Learning Preferences",
      subtitle: "",
      motherLanguage: "Your native language",
      motherLanguageInfo: "This will be used for UI and instructions",
      targetLanguage: "Language you're learning",
      languageLevel: "Your current level",
    },
    learningMotivation: {
      title: "Learning Motivation",
      subtitle: "Why did you decide to learn this language?",
      options: {
        relocation: "Relocation",
        exam: "Exam",
        travel: "Travel",
        relationship: "Relationship",
        career: "Career",
        family: "Family",
        other: "Something else!",
      },
    },
    learningGoals: {
      title: "Learning Goals",
      subtitle: "What are your learning goals?",
      options: {
        fluency: "Improve fluency",
        vocab: "Learn more words",
        idioms: "Native idioms",
        anxiety: "Overcome anxiety",
        job: "Get a job",
        other: "Something else!",
      },
    },
    learningSchedule: {
      title: "Learning Schedule",
      subtitle: "<b>Pro tip:</b> Our app works best when you practice a little bit (even just 5 minutes) almost every day, rather than longer sessions less frequently.",
      question: "How often do you plan to practice?",
      options: {
        few_times_per_day: "A few times per day",
        once_per_day: "Once per day",
        few_times_per_few_days: "A few times per few days",
        idk: "I don't know",
        other: "Something else!",
      }
    },
    termsOfService: {
      title: "Legal Information",
      termsOfService: "Terms of Service",
      privacyPolicy: "Privacy Policy",
      acceptTerms: "I accept the terms of service and privacy policy",
      confirmAge: 'I am at least 16 years old',
      confirmAgeInfo: 'Some countries require that AI chats are restricted to users who are at least 16 years old.',
    },
    completeSetup: "Start Learning",
  },
  examStatus: {
    title: 'Thank You for Completing the Exam Simulation!',
    postExamInfo: "Your language exam session has been completed successfully. \nWe hope you found this experience helpful for improving your speaking skills.",
    quickAssessment: {
      pleaseWait: 'Please wait while we process your results...',
      title: 'Quick Assessment',
      monologue: 'Monologue Assessment',
      dialogue: 'Dialogue Assessment',
      grammar: 'Grammar',
      vocabulary: 'Vocabulary',
      fluency: 'Fluency',
      totalScore: 'Total Score',
      feedback: 'Feedback:',
    },
    recordings: {
      title: 'Your Recordings',
      monologue: 'Monologue Recording',
      dialogue: 'Dialogue Recording',
      pleaseWait: 'The recording is being created...',
    },
    thankYou: {
      title: 'Thank you for completing our exam simulation!',
      reloadLater: "You can switch to another tab but do not close this one. Reload it later to get the teacher's full assessment.",
    }
  },  
  practiceResponseOptions: {
    title: 'Response suggestions',
    disabledTitle: 'Suggestions',
    dismiss: 'Dismiss',
    loading: 'Loading...',
    noOptions: 'No options found',
    tutorSaid: 'Tutor said:',
    enable: 'On',
    disable: 'Off',
  },
  balance: {
    buyMoreCredits: 'Buy More Credits',
    startCheckout: 'Go to Payment',
    thanks: 'Thank you for your purchase!',
    purchaseSuccessful: 'Purchase successful',
    aboutCredits: {
      title: 'How to use credits?',
      details: 'Credits are used to purchase AI-based services in the Chatlanga app. Our high-quality models and premium voice generation require serious GPU muscle 💪 and we work hard to keep them running smoothly.',
      services: {
        practice: {
          title: 'Speech Practice',
          detail: '5 minute practice session with a premium voice AI tutor',
        },
        exam: {
          title: 'Exam Session',
          detail: 'Exam simulation with three parts: presentation, dialog and description',
        },
        chatPackStandard: {
          title: 'Basic Response Pack',
          detail: '50 intelligent AI responses from our AI tutor in Telegram',
        },
        chatPackPremium: {
          title: 'Premium Response Pack',
          detail: '200 intelligent AI responses from our AI tutor in Telegram',
        }
      }
    }
  },
  coupons: {
    couponForm: {
      title: 'Coupon Activation',
      codeLabel: 'Your coupon code',
      codePlaceholder: 'Enter coupon code',
      submitButton: 'Submit',
    },
    modal: {
      title: 'Coupon Claimed!',
      detail: 'Your coupon code has been successfully applied.',
      defaultMessage: 'These credits have been added to your account.',
    },
    errors: {
      notFound: 'Coupon not found',
      alreadyClaimed: 'Coupon already claimed',
      failedToClaim: 'Failed to claim coupon',            
    }
  },
  support: {    
    tabs: {
      articles: 'Help Articles',
      myTickets: 'My Tickets',
    },
    articles: {
      title: 'Common Questions',
      botChatInfo: 'Don\'t be shy and ask our Telegram Chatlanga bot for help! It can provide basic support and escalate your case if needed.',
      telegramSupport: 'or get human support in Telegram',
    },
    ticketForm: {
      title: 'Submit Request',
      email: 'Email',
      emailPlaceholder: 'Your email...',
      topic: 'Topic',
      topicPlaceholder: 'Problem or suggestion...',
      type: 'Request Type',
      typePlaceholder: 'Select request type',
      requestType: {
        bug: 'Bug',
        suggestion: 'Suggestion',
        featureRequest: 'Feature Request',
        other: 'Other',
      },
      message: 'Message',
      messagePlaceholder: 'Describe your problem or suggestion...',
      submitButton: 'Submit',
      submitted: 'Request submitted successfully!',
    },
    myTickets: {
      title: 'My Tickets',
      createTicket: 'Create Ticket',
      noTickets: 'If you want to get help, click the button below to create a new support request:',
      createTicketButton: 'Create Ticket',
      ticketList: {
        open: 'Open',
        inProgress: 'In Progress',
        closed: 'Closed',
      },
    }
  },
  pushToTalk: {
    defaultLabel: 'Hold & Talk',
    recording: 'Release to send',
    processing: 'Wait...',
    speakNow: 'Speak now...',
  },
  soundTest: {
    title: "Audio test",
    instructionPrefix: "Say:",
    testPhrase: "I am ready to start",
    confirmationQuery: "Did you hear the audio response?",
    successMessage: "Sound test completed successfully!",
    micError: "Ensure microphone permissions and check if have any extra bluetooth devices connected",
    tabMutedError: "🔇 => 🔊 Check if your tab is muted!",
  },
  chatSpeechMeter: {
    info: function(wpm: number, minWpm: number, maxWpm: number, levelName: string) {
      return `You speak at ≈${wpm} words-per-minute. For ${levelName} the expected range is ${minWpm} - ${maxWpm} words-per-minute.`;
    },
  },
  voiceChat: {
    chatFlow: {
      title: "Voice Chat",
      playbackRate: "Voice playback rate",
      messagePlaceholder: "Type your message...",
      hints: {
        pushToTalk: "Hold or press to talk, press again or release to send",
        emotions: "Select an emotion to express how you feel!",
      },
      history: {
        assist: "Assist",
        notes: "Notes",
      },
      limitNoice: {
        title: "Daily limit reached",
        detail: "⏳ You have reached the daily limit for sending messages. Please wait till midnight for the limits to refresh.",
      }
    },
    inventory: {
      manager: {
        title: "Chat Inventory",
      },
      itemDetails: {
        acquiredInMessage: "Acquired in context:",
        emptyList: "The items that can be used in the chat or that you receive during the chat will appear here.",
        itemReceived: "Item received",
        itemLost: "Item given away",
      },
    },
    panels: {
      wordCounter: {
        title: "Words",
      },
      progress: {
        title: "Progress",
      },
      lives: {
        title: "Lives",
      },
    },
  },
  todoLists: {
    dashboardTitle: "Your Todos",
    currentTask: "Assignment:",
    item: {
      status: {
        completed: "Completed",
      }
    },
    drawer: {
      defaultLabel: "To Do Item",
      loading: "Please wait while the tutor prepares task notes for you...",
    },
    modals: {
      taskCompleted: {
        title: "Task Completed",
        continueLearning: "Continue Learning",
      },
      taskCreated: {
        title: "New Task",
      },
      rewardReceived: {
        title: "Reward Received",
      },
    }
  },
  imageOverlay: {
    zoomTip: "Double-tap to zoom • Pinch to zoom • Drag to pan",
  },
  feed: {
    miniChallengeButton: "Mini-Challenge",
    loader: {
      title: "Loading new posts",
      subtitle: "Preparing personalized content for you",
    },
    waitToLoadMore: {
      title: "Review current posts first!",
      subtitle: "Please check the current posts a few seconds before loading more",
    },
    addingContact: {
      title: "Adding Contact",
      subtitle: "You've got a new virtual contact!",
    },
    giftBox: {
      openMode: {
        hits: {
          title1: "Tap many times to open",
          title2: "Suprise waits inside!",
          title3: "Your random prize is here!",
        }
      },
      note: "Gift boxes contain new contacts, useful items and other rewards!",
    }
  },
  quizForm: {
    correct: "Correct: ",
    correctCount: "Correct: ",
    incorrectCount: "Mistakes: ",
    quizCompleted: "Quiz completed",
    quizCompletedDetail: "You have completed the quiz. You can try again to get higher scores.",
    repeatQuiz: "Do it again",
  },
  contacts: {
    newContactsNote: 'Get new contacts by finding new contacts in the "For You" feed! Read articles and solve quizzes to discover new 🎁 giftboxes!',
    contactTasks: 'Tasks:',
    startTaskChat: 'Start Task',
  },
  experienceBar: {
    gameLivesHint: 'Your game lives',
    rankHint: 'Your student rank',
    xpLeftToNextLevel: 'XP left to next level',
    xpGained: 'XP gained',
  },
  vocabularyPage: {
    vocabListTitle: 'Your Vocabulary',
    shortTitle: 'Vocab list',
    emptyList: 'No vocabulary saved yet. Use the \'Save\' button in word explainers to save words to your list.',
    wordGameButton: 'Flash cube',
  },
  wordGame: {
    cube: {
      title: 'Word Cube',
      questionLabel: 'Question:',
      translationLabel: 'What is the translation of:',
      instruction: 'Drag to rotate the shape to see all answer options.',
      otherDefinitions: 'Other definitions:',
      wordForIncorrectAnswer: 'Wrong word',
    },
    completeModal: {
      title: 'Game Complete!',
      effort: {
        veryLow: 'Ooops! 😭',
        low: 'Keep practicing! 📚',
        medium: 'Good effort! 💪',
        high: 'Great job! 🎉',
        veryHigh: 'Excellent! 🌟',
      }
    }
  }
};
